import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d5a1006"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-smp",
  role: "alertdialog",
  "aria-label": "Delete this segment's marks?"
}
const _hoisted_2 = { class: "nge-smp-row" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.segmentMarksPrompt.counts.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, "The segment you removed has " + _toDisplayString($setup.words) + " " + _toDisplayString($setup.total === 1 ? 'mark' : 'marks') + ". Delete " + _toDisplayString($setup.total === 1 ? 'it' : 'them') + "?", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "nge-smp-btn",
            onClick: _cache[0] || (_cache[0] = (...args) => ($setup.keepSegmentMarks && $setup.keepSegmentMarks(...args)))
          }, "Keep"),
          _createElementVNode("button", {
            type: "button",
            class: "nge-smp-btn nge-smp-btn--go",
            onClick: _cache[1] || (_cache[1] = (...args) => ($setup.deleteSegmentMarks && $setup.deleteSegmentMarks(...args)))
          }, "Delete")
        ])
      ]))
    : _createCommentVNode("v-if", true)
}